export default __webpack_public_path__ + "static/design-74edf7184fc747a61fad885c5575b923.jpg";